import clsx from 'clsx';

export function descriptionClassName(textAlign) {
  const isShifted = ['center', 'right'].includes(textAlign);
  return clsx('cp_rich-text cp_product-description', {
    // Outside markers pin to the left edge while the text moves with the alignment
    'cp_product-description--list-inside': isShifted,
    [`cp_product-description--align-${textAlign}`]: isShifted,
  });
}
